import { DefaultOptionType } from 'antd/es/select'

import { ClassifierControlsDataSource } from '../types'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { ClassifierControlsTypeDto, ClassifierControlCategoriesTypeDto } from '@app/api/routes/monitorings/dtos'

export const adaptClassiferControlsTableData = (
  classifierTypeResponse: ResponseDto<ClassifierControlsTypeDto>,
  MONITORING_CATEGORY_KEYS: Record<string, string>
): TableData<ClassifierControlsDataSource> => {
  const { count, results: classifierType } = classifierTypeResponse

  const dataSource: ClassifierControlsDataSource[] = classifierType.map(dto => ({
    key: dto.id,
    id: dto.id,
    name: dto.name,
    categoryId:
      MONITORING_CATEGORY_KEYS[dto.categoryId as keyof typeof MONITORING_CATEGORY_KEYS] ?? dto.categoryId ?? null
  }))

  return { count, dataSource }
}

export const adaptClassiferMonitoringCategoriesData = (
  categoryTypeResponse: ResponseDto<ClassifierControlCategoriesTypeDto>
): DefaultOptionType[] => {
  const { results: categoryType } = categoryTypeResponse

  return categoryType.map(dto => ({
    key: dto.id,
    value: dto.id,
    label: dto.title
  }))
}
